export default "__VITE_ASSET__CZ9s5t53__"